<!--
 * @Description: 跟进记录新增编辑
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-05-31 17:58:57
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <baseMessage :disabled="false" :data="form" returnPath="/fbu/visitorProgram" :permissionPage="permissionBasic" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import baseMessage from '../components/baseMessage.vue'
import { visitorProgramDetail } from '@/api/gucangSales/followUpManage'
import type { FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
const route = useRoute()
const form = ref<FbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: {}
})
const permissionBasic = {
  save: 'fbu_visitor_complete_btn'
}
// 获取访客计划详情
const getvisitorProgramDetail = () => {
  visitorProgramDetail(route.query.planId as string).then((res) => {
    const {
      id,
      mode,
      customerName,
      endTime,
      startTime,
      chanceName,
      contactId,
      visitRefId,
      chanceId,
      purpose,
      fbuAssistPersons
    } = res.data
    form.value = {
      ...form.value,
      planId: id,
      mode,
      customerName,
      endTime,
      startTime,
      contactId,
      chanceId,
      chanceName,
      fbuPurpose: purpose,
      fbuAssistPersons,
      followRefId: visitRefId
    }
  })
}
onMounted(() => {
  if (route.query.planId) {
    getvisitorProgramDetail()
  }
})
</script>
<script lang="ts">
export default {
  name: 'DcCosFbuFollowUpRecordVisitingPlan'
}
</script>
